module.exports = __webpack_public_path__ + "img/price.384f9027.png";